<script setup>
import { computed, nextTick, ref, useTemplateRef } from 'vue'

const model = defineModel()
const input = useTemplateRef('input')

const visible = ref(false)

const t = computed(() => (visible.value ? 'text' : 'password'))
const cl = computed(() => ({
  bi: true,
  'bi-eye-slash': !visible.value,
  'bi-eye': visible.value,
}))

async function toggle() {
  const length = input.value.value.length

  visible.value = !visible.value

  await nextTick()
  input.value.focus()
  input.value.setSelectionRange(length, length)
}
</script>

<template>
  <div class="password-input">
    <input
      v-model="model"
      autocomplete="off"
      :type="t"
      ref="input"
      class="form-control"
    />
    <button
      type="button"
      class="toggle-button"
      @click="toggle"
    >
      <i :class="cl" />
    </button>
  </div>
</template>
